import type { FaireProductEntity } from "../../entity_types/product";

export const p_z338nz4y7f: FaireProductEntity = {
  token: "p_z338nz4y7f",
  type: "product",
  name: "6\" Arizona Souvies® Saguaro",
  brandToken: "b_40uiyujpi6",
  brandName: "Plushology® by RGU",
  imageUrl: "https://cdn.faire.com/fastly/e46f0a9af6fa557e28c65534d9ff4bd99b5d00896f32a4ff7325dda9808705b6.jpeg",
  galleryImageUrls: [],
  priceDollars: 9,
  description: "This Souvies® Arizona stuffed Saguaro cactus is lovingly embroidered with an exclusive Arizona name-drop, perfect for any souvenir collection, gift, or to show off your local pride! Plush Saguaro cactus is 6\" tall and weighs 8 ounces. Super soft, non-toxic, made by hand.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:12.898Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
